// ./src/utils/reportRecords.js
const recordsEstimates = 0; // types of records, selected from controls component
const recordsCompleted = 1;
const recordsPayments = 2;
const typeService = 1; // job types from database list object
const typeInstall = 3;
const typeCommercial = 4;
const apptEstimate = 1; // appointment types from database list object
const apptService = 2; 

export const getTermDays = (yearsOffset = 0, reports) => {
	const startDate = new Date(reports.startDate);
	const endDate = new Date(reports.endDate);
	const diffTime = endDate - startDate;
	const dayMilSecs = 1000 * 60 * 60 * 24;
	const termLength = Math.ceil(diffTime / dayMilSecs);

	return Array.from({ length: termLength }, (_, i) => i + 1).map((day) => {
		const adjustedStartDate = offsetDate(reports.startDate, yearsOffset);
		const date = new Date(adjustedStartDate);
		date.setDate(date.getDate() + day);
		return date.toISOString();
	});
};

export const offsetDate = (dateStr, years) => {
	const d = new Date(dateStr);
	d.setFullYear(d.getFullYear() - years);
	return d.toISOString().split("T")[0];
};

// Gets Appointments or Payments and filters based on date and job type
export const getRecords = (yearsOffset = 0, reports) => {
	let records = [];
	let appts = reports.appointments;
	const adjustedStartDate = offsetDate(reports.startDate, yearsOffset);
	const adjustedEndDate = offsetDate(reports.endDate, yearsOffset);
	console.log("startDate:", reports.startDate);
	console.log("adjustedStartDate:", adjustedStartDate);
	// Filter appointments for estimates
	if (reports.recordsType === recordsEstimates) {
		appts = appts?.filter((appt) => appt.appt_types_id === apptEstimate);
	}
	// Filter appointments for scheduled work
	else if (reports.recordsType === recordsCompleted) {
		appts = appts?.filter((appt) => appt.appt_types_id === apptService);
	}
	// If receipts selected return payments in date range
	if (reports.recordsType === recordsPayments) {
		records = reports.payments?.filter(
			(payment) =>
				payment.payment_date >= adjustedStartDate && payment.payment_date <= adjustedEndDate
		);
	}
	// Otherwise return appointments within date range
	else {
		records = appts?.filter((appt) => {
			const apptDate = appt.appt_date?.split("T")[0].split(" ")[0];
			return apptDate >= adjustedStartDate && apptDate <= adjustedEndDate;
		});
	}

	// Filter records based on Job Type
	console.log("records filtered by date: ", records);
	const filteredRecords = records?.filter((rec) => {
		const jobType = reports.jobs?.filter((job) => job.id === rec.core_job_data_id)[0]?.job_type_id;
		// Filter based on job type
		if (reports.includeService && jobType === typeService) {
			return true;
		}
		if (reports.includeInstall && jobType === typeInstall) {
			return true;
		}
		if (reports.includeCommercial && jobType === typeCommercial) {
			return true;
		}
	});

	console.log("records filtered by date and type: ", filteredRecords);
	return filteredRecords
};
